import { useEffect } from "react";
import { useDispatch, useSelector } from "react-redux";
import { Button, Modal, ModalBody, ModalFooter, ModalHeader } from "reactstrap";
import { deleteGrievanceApi } from "../api/grievancesApi";


const DeleteGrievaceConfirmModal = (props: any) => {
    const { toggle, openModal } = props;
    const dispatch: any = useDispatch();
    const closeBtn = (
        <img src={require('../assets/img/close_modal.svg').default} onClick={() => { toggle(); props.setFlag(false)}} style={{ cursor: 'pointer' }}></img>
    );

    const deleteGrievance = () => {
        dispatch(deleteGrievanceApi(props?.grievanceId))
    }

    const {
        storeDeleteGreivanceRes
    } = useSelector((state: any) => state.grievances)

    useEffect(() => {
        if(storeDeleteGreivanceRes?.data == 'deleted'){
            toggle();
            props.setFlag(true)
        }
    },[storeDeleteGreivanceRes])
    
    return (
        <Modal isOpen={openModal} toggle={toggle} centered={true} backdrop={'static'}>
            <ModalHeader toggle={toggle} close={closeBtn}></ModalHeader>
            <ModalBody>
                <span style={{textAlign:'center'}}>
                    Do you want to delete the Grievance record for the Grievance ID: <b>{props?.grievanceId}</b> ?
                </span>
            </ModalBody>
            <ModalFooter>
                <Button 
                    type='submit' 
                    className="button" 
                    style={{ width: '91px' }}
                    onClick={deleteGrievance}
                >
                    Yes
                </Button>{' '}
                <Button 
                    onClick={() => { toggle();props.setFlag(false)}} 
                    className="resetButton" 
                    style={{ width: '91px' }}
                >
                    No
                </Button>
            </ModalFooter>
            
        </Modal>
    );
}


export default DeleteGrievaceConfirmModal;